import React, { useState } from "react";
import "./ContactSection.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt
} from "react-icons/fa";

export default function ContactSection() {
  const [service, setService] = useState("");
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const whatsappNumber = "7200039384";
    const text = `Contact Enquiry
Name: ${name}
Phone: ${phone}
Service: ${service}
Message: ${message}`;

    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`,
      "_blank"
    );
  };

  return (
    <section className="contact-section">
      <div className="contact-card">
        <h1 className="contact-title">CONTACT US</h1>
        <p className="contact-sub">
          Please fill out the form and send enquiry. We will get back to you as soon as possible.
        </p>

        <div className="contact-wrapper">
          {/* LEFT INFO */}
          <div className="contact-info">
            <div className="info-row">
              <FaMapMarkerAlt />
              <div>
                <h4>Address</h4>
                <p>
                  Office Address <br />
                  725-D, Avinashi Road, S.R. Complex, Coimbatore - 641018
                </p>
              </div>
            </div>

            <div className="info-row">
              <FaPhoneAlt />
              <div>
                <h4>Phone</h4>
                <p>+91 7200039384</p>
              </div>
            </div>

            <div className="info-row">
              <FaEnvelope />
              <div>
                <h4>Email</h4>
                <p>info@aerlis.in</p>
              </div>
            </div>
          </div>

          {/* FORM */}
          <form className="contact-form" onSubmit={handleSubmit}>
            <select
              value={service}
              onChange={(e) => setService(e.target.value)}
              required
            >
              <option value="">-- Select Services --</option>
              <option>Insurance</option>
              <option>Loan</option>
              <option>Internship</option>
            </select>

            <textarea
              placeholder="Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />

            <input
              type="text"
              placeholder="Phone number*"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />

            <input
              type="text"
              placeholder="First name*"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />

            <div className="form-bottom">
              <button type="submit">Send Now</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
